import { ref, type Ref } from "vue";
import type { PublicEvent } from "@evka/shared";
import { ApiError, getEvent } from "../api";

export interface UseEvent {
  event: Ref<PublicEvent | null>;
  loading: Ref<boolean>;
  error: Ref<string | null>;
  errorCode: Ref<string | null>;
  load: (eventId: string) => Promise<void>;
}

/** Single-shot event fetch with error capture. */
export function useEvent(): UseEvent {
  const event = ref<PublicEvent | null>(null);
  const loading = ref(false);
  const error = ref<string | null>(null);
  const errorCode = ref<string | null>(null);

  async function load(eventId: string): Promise<void> {
    loading.value = true;
    error.value = null;
    errorCode.value = null;
    try {
      event.value = await getEvent(eventId);
    } catch (err) {
      event.value = null;
      if (err instanceof ApiError) {
        errorCode.value = err.code;
        error.value = err.message;
      } else {
        errorCode.value = "network_error";
        error.value = err instanceof Error ? err.message : String(err);
      }
    } finally {
      loading.value = false;
    }
  }

  return { event, loading, error, errorCode, load };
}
